import React, { useState } from 'react'
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import { Paper, Typography, FormControl, InputLabel, Select,
    FormHelperText, Input, InputAdornment, Tooltip, Button,
    TextField, NativeSelect, InputBase, MenuItem,
    FormControlLabel, Checkbox } from '@material-ui/core';
//import tokenLogo from '../images/ij-logo.jpg'
//import ethLogo from '../images/eth-logo.png'

const BuyForm = ({ ethBalance, buyTokens, tokenBalance, exchangeRateDisplay }) => {
    const [output, setOutput] = useState(0);
    const [input, setInput] = useState(0);


    return (
        <div>
          <Paper style={{ backgroundColor: 'rgb(108, 117, 125)', margin: '20px' }}>
          <br/><br/><br/><br/>
        <div style={{ paddingTop: '15px' }}>
          <Input 
            style={{ 'color': '#f50057' }} 
            label='Enter ETH'
            color='secondary'
            type="text"
            onChange={(event) => {
              const tokenAmount = event.target.value;
              setInput(tokenAmount);
              setOutput(tokenAmount * 1000);
            }}
            placeholder="0"
            required />
          <div>
            <div>
              {/* <img src={tokenLogo} height='32' alt=""/> */}
              &nbsp; ETH
            </div>
          </div>
        </div>
        <div>
          <Input style={{ 'color': 'rgb(163, 222, 158)' }}
            type="text"
            value={output}
            disabled
          />
          <div>
            <div>
              {/* <img src={ethLogo} height='32' alt=""/> */}
              &nbsp; RCT
            </div>
          </div>
        </div><br />
        <div className="mb-5">
          <span>Exchange Rate ~ 1000 RCT = 1 ETH</span>
        </div><br /><br />
        <Button
            variant='contained'
            color='secondary' 
            onClick={() => { buyTokens(input, output)}}       
        >Exchange</Button><br/><br/><br/><br/><br/>
        </Paper>
    </div>
    );

}

export default BuyForm;
